
<a (click)="goHome()">
  <img src="assets/images/back-arrow.png" alt="" class="img-fluid back-arrow">
  <label class="home"> Home</label>
</a>
